<template>

  <v-layout row wrap justify-center>

  </v-layout>

</template>

<script>
  export default {
    data: () => ({
      
    })
  }
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/Login.vue